/**
 * @author Radek Liška <ing.radek.liska@gmail.com>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

// @ts-check

import { literal } from '../../util.type';

export default {
  name: literal('layout'),
  methods: {
    toString() {
      return `Layout {id: "${this.id}"}`;
    }
  },
  relations: {
    belongsTo: {
      medium: {
        localField: 'backgroundMedium',
        localKey: 'backgroundMediumId'
      }
    },
    hasMany: {
      layer: {
        localField: 'layers',
        foreignKey: 'parentLayoutId'
      }
    }
  }
};
